// extracted by mini-css-extract-plugin
export default {"imageWrapper":"UG-z","hovered":"VG-z","hoverImage":"WG-z","mainImage":"XG-z","imageNoBackground":"YG-z","fullSizeImage":"ZG-z"};